export enum TimelineBehavior {
    AUTO = 'AUTO',
    STATIC = 'STATIC',
    SLIDE = 'SLIDE',
    STRETCH = 'STRETCH',
}
